<template>
    <div class="ebPanelHeader">
        <div class="panelTitle clearfix">
            <slot name="title"></slot>
            <div class="panelTitle_button">
                <slot name="button" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'ebPanelHeader'
};
</script>
<style scoped lang="less">
.ebPanelHeader {
  .panelTitle {
    color: #fb5b3b;
  }
  .panelTitle_button {
    float: right;
  }
}
</style>
